import Keycloak from 'keycloak-js'

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({
  url: process.env.KEYCLOAK_URL,
  realm: 'ClapTech',
  clientId: process.env.KEYCLOAK_CLIENT_ID,
  'auth-server-url': process.env.KEYCLOAK_URL,
  'ssl-required': 'none',
  resource: process.env.KEYCLOAK_CLIENT_ID,
  'public-client': true,
  useNonce: false,
})
export default keycloak
